import { Children } from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import { unit } from '../../styles/unit';
import { jsx as _jsx } from "react/jsx-runtime";
const Column = /*#__PURE__*/styled.span.withConfig({
  displayName: "Column",
  componentId: "sc-1y59zrz-0"
})(["vertical-align:middle;:not(:last-child){margin-right:", ";}"], unit(2));

const NavigationLabel = ({
  children
}) => Children.map(children, child => child && /*#__PURE__*/_jsx(Column, {
  children: child
}));

NavigationLabel.propTypes = {
  children: T.node
};
export { NavigationLabel };